import 'public/loader-animations.css';
import 'public/loader-base.css';

interface SageLogoAnimationProps {
    skipIntro?: boolean;
}

function SageLogoAnimation(props: SageLogoAnimationProps) {
    const { skipIntro = false } = props;
    return (
        <div className={`sage-loader ${skipIntro ? 'no-intro' : ''}`}>
            <svg
                className="sage-logo"
                width="72px"
                height="79px"
                viewBox="0 0 72 79"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
            >
                <path d="M35.9964 36.2625C40.0358 36.2625 43.3111 28.1449 43.3111 18.1313C43.3111 8.11763 40.036 0 35.9964 0C31.9569 0 28.6816 8.11763 28.6816 18.1313C28.6816 28.1449 31.9569 36.2625 35.9964 36.2625Z" />
                <path d="M63.2821 29.4248C70.3993 22.3442 73.8536 14.3005 70.9973 11.4581C68.141 8.61652 60.0556 12.0522 52.9376 19.1328C45.8203 26.2133 42.366 34.257 45.2232 37.0994C48.0795 39.941 56.1648 36.5045 63.2821 29.424V29.4248Z" />
                <path d="M70.9955 67.5368C73.8527 64.6952 70.3983 56.6515 63.2811 49.5709C56.1638 42.4904 48.0785 39.0539 45.2222 41.8963C42.3659 44.7379 45.8202 52.7816 52.9375 59.8621C60.0548 66.9427 68.1401 70.3792 70.9955 67.5368Z" />
                <path d="M35.9964 78.9998C40.0358 78.9998 43.3111 70.8822 43.3111 60.8686C43.3111 50.855 40.036 42.7374 35.9964 42.7374C31.9569 42.7374 28.6816 50.855 28.6816 60.8686C28.6816 70.8822 31.9569 78.9998 35.9964 78.9998Z" />
                <path d="M19.0621 59.8644C26.1794 52.7838 29.6337 44.7402 26.7774 41.8978C23.9211 39.0562 15.8358 42.4927 8.7185 49.5733C1.60123 56.6538 -1.85304 64.6975 1.00324 67.5399C3.85954 70.3815 11.945 66.9457 19.0621 59.8644Z" />
                <path d="M26.7772 37.1017C29.6336 34.2601 26.1793 26.2156 19.0621 19.135C11.9448 12.0545 3.85945 8.618 1.00315 11.4604C-1.85313 14.302 1.60115 22.3457 8.71841 29.4263C15.8357 36.5068 23.921 39.9433 26.7772 37.1017Z" />
            </svg>
        </div>
    );
}

export default SageLogoAnimation;
